import { Input } from "./ui/input";
import { Label } from "./ui/label";

const STATUS_COLORS = {
  PENDING: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  PENDING_PAYMENT: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  APPROVED: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  PAYMENT_APPROVED: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  MISMATCH: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  IN_QUALIFICATION: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  WAITING_REVIEW: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  ACTIVE: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  OPEN: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  RUNNING: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  REJECTED: "bg-red-500/15 text-red-300 border-red-500/30",
  CLOSED: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  COMPLETED: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  DRAFT: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  ARCHIVED: "bg-slate-500/15 text-slate-400 border-slate-500/30",
};

export function StatusBadge({ status, testId }) {
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider ${STATUS_COLORS[status] || "bg-white/5 text-slate-300 border-white/10"}`}>
      {status}
    </span>
  );
}

export function Field({ label, testId, ...props }) {
  return (
    <div className="space-y-1.5">
      <Label className="text-slate-300 text-sm">{label}</Label>
      <Input data-testid={testId} className="bg-[#1C202E] border-white/10 text-white h-10" {...props} />
    </div>
  );
}

export function PageHeader({ eyebrow, title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
      <div>
        {eyebrow && <span className="text-xs uppercase tracking-[0.2em] text-[#10B981] font-semibold">{eyebrow}</span>}
        <h1 className="mt-2 font-[Outfit] text-4xl font-extrabold text-white tracking-tight">{title}</h1>
        {subtitle && <p className="text-slate-400 mt-2">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}

export function EmptyState({ text, testId }) {
  return (
    <div data-testid={testId} className="rounded-xl border border-dashed border-white/10 px-6 py-12 text-center text-slate-500 text-sm">
      {text}
    </div>
  );
}

export const formatIDR = (n) => new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n || 0);
